"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Notification = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _fonts = require("../fonts");
var _Svg = require("../Svg");
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var exclamationPoint = function exclamationPoint(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M10 20C4.477 20 0 15.523 0 10C0 4.477 4.477 0 10 0C15.523 0 20 4.477 20 10C20 15.523 15.523 20 10 20ZM10 18C12.1217 18 14.1566 17.1571 15.6569 15.6569C17.1571 14.1566 18 12.1217 18 10C18 7.87827 17.1571 5.84344 15.6569 4.34315C14.1566 2.84285 12.1217 2 10 2C7.87827 2 5.84344 2.84285 4.34315 4.34315C2.84285 5.84344 2 7.87827 2 10C2 12.1217 2.84285 14.1566 4.34315 15.6569C5.84344 17.1571 7.87827 18 10 18ZM9 13H11V15H9V13ZM9 5H11V11H9V5Z",
    fill: "#41C6A7"
  }));
};
exclamationPoint.defaultProps = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Svg = (0, _styledComponents.default)(_Svg.Svg)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  margin-right: 12px;\n"])));
var Wrapper = _styledComponents.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  color: ", ";\n  min-height: 68px;\n  padding: 10px 12px;\n  display: flex;\n  align-items: center;\n  border-radius: ", ";\n  background-color: ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.tertiary;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.radius.xl;
}, function (_ref3) {
  var _theme$notificationCo, _theme$notificationCo2;
  var theme = _ref3.theme,
    $type = _ref3.$type;
  return (_theme$notificationCo = (_theme$notificationCo2 = theme.notificationColors[$type]) === null || _theme$notificationCo2 === void 0 ? void 0 : _theme$notificationCo2.bgColor) !== null && _theme$notificationCo !== void 0 ? _theme$notificationCo : theme.colors.secondary;
});
var Title = (0, _styledComponents.default)(_fonts.H6)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: block;\n  color: ", ";\n  margin-bottom: 5px;\n"])), function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.tertiary;
});
var Description = (0, _styledComponents.default)(_fonts.Small)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  display: block;\n  color: ", ";\n"])), function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.tertiaryShade;
});
var Notification = function Notification(_ref6) {
  var title = _ref6.title,
    content = _ref6.content,
    type = _ref6.type,
    className = _ref6.className;
  return /*#__PURE__*/_react.default.createElement(Wrapper, {
    $type: type,
    className: className
  }, /*#__PURE__*/_react.default.createElement(Svg, {
    as: exclamationPoint,
    color: type
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "w-100"
  }, typeof title === 'string' ? /*#__PURE__*/_react.default.createElement(Title, null, title) : title, typeof content === 'string' ? /*#__PURE__*/_react.default.createElement(Description, null, content) : content));
};
exports.Notification = Notification;